import styled from '@emotion/styled'
import { Icon, Theme, TIcons, Tooltip } from '@yuno/design-system-web'

type StyledProps = { theme?: Theme }

type ConnectionCurrencyCardProps = {
  title: string
  description: string
  symbol: string
  icon: TIcons
}

const Container = styled('div')<StyledProps>`
  width: 215px;
  height: 64px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
`

const Flex = styled('div')<StyledProps>`
  display: flex;
`

const ImageContainer = styled('div')<StyledProps>`
  width: 44px;
  height: 44px;
  background: ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled('p')<StyledProps>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-size: ${({ theme }) => theme.typography.base.bold.fontSize};
  font-weight: ${({ theme }) => theme.typography.base.bold.fontWeight};
  margin: 3px 0px 0px 0px;
`

const Description = styled('p')<StyledProps>`
  color: ${({ theme }) => theme.palette.grey[6]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-weight: ${({ theme }) => theme.typography.tiny.regular.fontWeight};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  margin: 0px;
`

const TextContainer = styled('div')`
  margin-top: 7px;
`

const Symbol = styled('span')<StyledProps>`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.base.regular.fontSize};
`

const ConnectionCurrencyCard = ({
  title,
  description,
  symbol,
  icon,
}: ConnectionCurrencyCardProps) => {
  const getDescription = () => {
    if (description.length > 22) {
      return (
        <Tooltip title={description} color="default">
          <Description>{`${description.slice(0, 18)}...`}</Description>
        </Tooltip>
      )
    }
    return <Description>{description}</Description>
  }

  return (
    <Container>
      <Flex>
        <ImageContainer>
          <Symbol>{icon ? <Icon name={icon} size="18px" /> : symbol}</Symbol>
        </ImageContainer>
        <TextContainer>
          <Title>{title}</Title>
          {getDescription()}
        </TextContainer>
      </Flex>
    </Container>
  )
}

export default ConnectionCurrencyCard
